import { Heading } from 'components/Heading';
import { Para } from 'components/Para';
import { Spacer } from 'components/Spacer';
import { MobileScreen } from 'components/MobileScreen';
import { navigateBack } from 'engine/api';
import { Globe, Mail } from 'lucide-react';
import { router } from 'src/main';
import { appConfig } from 'engine/appConfig';

export function About() {
	return (
		<MobileScreen className="flex h-full flex-col items-center gap-6">
			<Heading mode="primary" className="w-full text-left">
				{__`About ${appConfig.title}`}
			</Heading>
			<Para className="whitespace-pre-line text-left">{__`about.Body`} </Para>
			<Heading mode="secondary" className="w-full text-left">
				{__`Contact`}
			</Heading>
			<Para className="w-full text-left">{__`contact.Body`}</Para>
			<div className="flex w-full flex-col gap-1 text-left">
				<a href="mailto:info@bedrijfshelden.nl" className="flex items-center gap-2">
					<Mail className="size-4" />
					<span className="underline">info@bedrijfshelden.nl</span>
				</a>
				<div className="flex items-center gap-2">
					<a href="https://bedrijfshelden.nl" target="_blank" className="flex items-center gap-2">
						<Globe className="size-4" />
						<span className="underline">bedrijfshelden.nl</span>
					</a>
				</div>
			</div>
			<Heading mode="secondary" className="w-full text-left">
				BedrijfsHelden
			</Heading>
			<div className="w-full text-left">
				<Para>Venhofstraat 2</Para>
				<Para>5384 SZ Heesch, The Netherlands</Para>
				<br />
				<Para>KvK 69136726</Para>
				<Para>NL NL001802940B64</Para>
			</div>
			<Spacer />
			<button onClick={() => navigateBack(router, 'slide-right')} className="font-bold">
				{__`Back`}
			</button>
		</MobileScreen>
	);
}
